export const formatTime = (time: string): string => {
  return time;
};

export const generateTimeSlots = (startHour: number = 6, endHour: number = 22): string[] => {
  const slots: string[] = [];
  for (let hour = startHour; hour <= endHour; hour++) {
    slots.push(`${hour.toString().padStart(2, '0')}:00`);
  }
  return slots;
};

export const getTimeFromHour = (hour: number): string => {
  return `${hour.toString().padStart(2, '0')}:00`;
};

export const getHourFromTime = (time: string): number => {
  return parseInt(time.split(':')[0]);
};

export const formatDate = (date: string): string => {
  // Parse date as UTC to avoid timezone shifting
  const [year, month, day] = date.split('-').map(Number);
  const d = new Date(Date.UTC(year, month - 1, day));
  return d.toLocaleDateString('pl-PL', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
};

export const getTodayDate = (): string => {
  // Get local date (not UTC) for "today" comparison
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const addDays = (date: string, days: number): string => {
  // Parse date as UTC components to avoid timezone issues
  const [year, month, day] = date.split('-').map(Number);
  // Create date in UTC and add days
  const result = new Date(Date.UTC(year, month - 1, day + days));
  return result.toISOString().split('T')[0];
};

export const generate7DayRange = (startDate: string): string[] => {
  const dates: string[] = [];
  for (let i = 0; i < 7; i++) {
    dates.push(addDays(startDate, i));
  }
  return dates;
};

export const formatPrice = (price: number): string => {
  return parseFloat(price.toFixed(2)).toString();
};

export const formatDateShort = (date: string): string => {
  // Parse date as UTC to avoid timezone shifting
  const [year, month, day] = date.split('-').map(Number);
  const d = new Date(Date.UTC(year, month - 1, day));
  // Use UTC formatting to get consistent results
  return d.toLocaleDateString('pl-PL', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
};
